<template>
  <v-app id="app" class="public-app">
    <v-main style="overflow: hidden">
      <router-view/>
      <fin-cookie-declaration/>

    </v-main>
    <fin-alert/>
    <fin-lexicon-overlay/>
  </v-app>
</template>

<script>
import FinCookieDeclaration from "@/components/common/FinCookieDeclaration"
import FinAlert from "@/components/common/alert"
import FinLexiconOverlay from "@/components/common/lexicon/LexiconOverlay"


export default {
  name: 'PublicApp',
  components: {
    FinLexiconOverlay,
    FinAlert,
    FinCookieDeclaration,
  },
}
</script>

<style lang="scss" scoped>
.public-app {
  background-color: #ffffff !important;
}
</style>
